<template>
  <b-card title="Çek&Senet">
    <b-list-group>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Tanım
        </div>
        <div>{{ dataItem.title }}</div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Notlar
        </div>
        <div>{{ dataItem.notes }}</div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Vade Tarihi
        </div>
        <div>{{ moment(dataItem.expiry_date).format('DD.MM.YYYY') }}</div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Toplam Tutar
        </div>
        <div class="text-danger font-weight-bolder">
          {{ dataItem.amount | toCurrency }} TL
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="font-weight-bold text-primary">
          Kalan Tutar
        </div>
        <div class="text-danger font-weight-bolder">
          {{ dataItem.balance_amount | toCurrency }} TL
        </div>
      </b-list-group-item>
      <b-list-group-item>
        <div class="text-muted font-small-2">
          {{ moment(dataItem.created).format('LLLL') }} tarihinde {{ dataItem.username }} tarafından oluşturuldu.
        </div>
        <div
          v-if="dataItem.modified"
          class="text-muted font-small-2"
        >
          {{ moment(dataItem.modified).format('LLLL') }} tarihinde {{ dataItem.username }} tarafından güncellendi.
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="dataItem.balance_amount === 0">
        <status-card />
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>
<script>
import {
  BCard, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import StatusCard from '@/views/Admin/Promissories/View/StatusCard.vue'

export default {
  name: 'ViewCard',
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
    StatusCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['promissories/dataItem']
    },
  },
  created() {
    this.getPromissoryStatuses()
  },
  methods: {
    getPromissoryStatuses() {
      this.$store.dispatch('promissoryStatuses/getDataList')
    },
  },
}
</script>
